module.exports = __webpack_public_path__ + "static/img/bcg_k10.9a255814.png";